import { Cancel, Delete, KeyboardArrowDown, KeyboardArrowUp, Print , Refresh  } from '@mui/icons-material';
import { Box } from '@mui/material';
import * as Sentry from "@sentry/react";
import {
  Button as AntdButton,
  Select as AntSelect,
  Col,
  Dropdown,
  Modal,
  Row,
  Skeleton,
  Space,
  Tooltip
} from "antd";
import { DeleteModal } from "components/Dialog";
import Loading from "components/Loading";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import QnALoader from "components/VocabQnAModal/QnALoader";
import { useMobileDetect, useTabletDetection } from "containers/chat/hooks";
import { filter, find } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { handleDeleteStoryAiConfig, handleGetStoryMediaStatus, handleRegenerateStory } from "store/StoryAiCofig/thunks";
import { useSuperLesson } from "store/SuperLesson/selectors";
import { useCurrentUser, useUserProfileConfig } from "store/users/selectors";
import { useVocabulary } from "store/vocabulary/selectors";
import styled from "styled-components";
import { question_type_generate_more } from "utils/config/reference";
import {
  addPrintableClass,
  removePrintableClass,
} from "utils/methods/textMethod";
import StoryBoard from "../../utils/assets/images/storyboard1.png";
import Writing from "../../utils/assets/images/writing1.png";
import StoryShare from "./StoryShare";
import StoryTextEditor from "./StoryTextEditor";
import StoryWithImages from "./StoryView";
import { handleStreamResponse } from 'utils/methods/QuestionCreateStreamHandle';
import AIUsageInfo from 'components/Modals/AiInfoModal';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import { handleLearningModuleCount } from 'store/bingo/thunks';
import { Badge } from '@mui/material';
import SentryWrap from 'components/Sentry';
import { isErrorContent } from "utils/methods/storyContentValidation";
const LessonContainer = styled.section`
  margin-top: ${(p) => (p.pathname === "/ebook" ? "37px" : "0px")};
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: ${({ currentUser }) => currentUser?.role === 'student' ? 2 : 50} ;
  top : 0;
`;

const LessonModal = styled.div`
  background: #000f4c;
  padding-left: ${(p) => (p.view ? "51px" : "15px")};
  padding-right: ${(p) => (p.view ? "51px" : "15px")};
  padding-bottom: ${(p) => (p.view ? "34px" : "26px")};
  padding-top: ${(p) => (p.view ? "51px" : "17px")};
  height: ${(p) => (p.view ? "unset" : p.bookPage ? "97%" : "100%")};
  @media Screen and (max-width: 600px){
    // height:110% !important;
        overflow: hidden;
  }
  @media Screen and (min-width:801px) and (max-width: 830px){
    height: ${(p) => (p.soyHistoria ? "100%" : "120%")};
    soyHistoria
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
`;

const BoxContainer = styled.div`
  display: flex;

  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const Label = styled.label`
  color: #fff;
  // font-family: "Gotham";
  font-size: 14px;
  font-weight: 400;
  // font-family: Gotham;
  white-space: nowrap;
  @media (max-width: 768px) {
    color: #fff;
    font-size: 13px;
     
    font-weight: 400;
  }
`;

const FieldShareBox = styled.div`
  display: grid;
  place-items: center;
  border-radius: 9.5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  text-align: center;
  min-width: 63px;

  width: 100%;
  height: 31px;
  color: #000;
  // font-family: Gotham;
  font-size: 12px;
   
  font-weight: 400;
  flex: 1;
  @media (max-width: 768px) {
    color: #000;
    // font-family: "Gotham";
    font-size: 10px;
     
    font-weight: 400;
  }
    .ant-select-selection-item{
      text-align:left;
    }
`;

const FieldBoxState = styled.div`
  display: grid;
  place-items: center;
  border-radius: 9.5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  text-align: center;
  min-width: 85px;

  // width: 108px;
  height: 19px;
  color: #000;
  // font-family: Gotham;
  font-size: 12px;
   
  font-weight: 400;
  flex: 1;
  max-width: 241px;

  @media (max-width: 768px) {
    color: #000;
    // font-family: "Gotham";
    font-size: 10px;
     
    font-weight: 400;
  }
`;

const DeleteIcon = styled(Delete)`
    font-size: 18;
    cursor: pointer;
    color: red;
    // margin-left:auto;
`;
const DropDownOption = styled.div`
  display:flex;
  flex-direction:row,
  justify-content: flex-start;
  align-items: center;
  width:100%;
  margin:0px;
`



const VocabDisplay = ({ vocab_list }) => {
  const vocabArray = vocab_list?.split(',').filter(Boolean) || [];
  return (
    <Box>
         <Label style={{ position: 'absolute', zIndex: 9, top: -22 }}>Vocabulary</Label>
      <Box
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          overflowY: 'auto',
          maxHeight: 100,
          // gap: 8,
          // backgroundColor: "#fff",
          // borderRadius: 4,
        }}
      >
        {/* {vocabArray.map((word, index) => (
          <Chip key={index} label={word} style={{ margin: 4 }} />
        ))} */}
        <Space direction="vertical" style={{ width: "100%" }}>
          <AntSelect
            style={{ width: "100%" }}
            placeholder="Select a story"
            value={vocabArray}
            className="dropdown-select"
            optionLabelProp="label"
          >
            {vocabArray.map((item, i) => <p key={i}>{item}</p>)}
          </AntSelect>
        </Space>
      </Box>
    </Box>
  );
};


const StoryViewModal = ({
  open,
  from,
  onClose,
  viewLessonType,
  isCanvasUser,
  hasStoryWithAi,
  onMoreStory = () => {},
  handleStoryId,
  setOpenStoryWithAiView,
  imageConfiguration,
  soyHistoria,
  handleStoryStream,
  handleStoryStreamTitle,
  setHandleStoryStream,
  setHandleStoryStreamTitle
}) => {
  const showAlert = useAlert();
  const imageRef = useRef();
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const superLesson = useSuperLesson();
  const [showShareList, setShowShareList] = useState(true);
  const [printLoader, setPrintloader] = useState(false);
  const location = useLocation();
  const [selectedValue, setSelectedValue] = useState(null);
  const [listStory, setListStory] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [storyIdPendingDelete, setStoryIdPendingDelete] = useState(null);
  const [frozenStories, setFrozenStories] = useState([]);

  const [deleteLoading, setDeleteLoader] = useState(false);
  const [regenerateLoader, setRegenerateLoader] = useState(false);
  const [regeneratingStoryId, setRegeneratingStoryId] = useState(null);
  const previousStoryRef = useRef(null);
  const regenerateTimeoutRef = useRef(null);
  const [selectedTypes, setSelectedTypes] = useState(
    question_type_generate_more.map((option) => option.value)
  );
    const bookVocabulary = useVocabulary();
  const [questionLoader, setQuestionLoader] = useState(false);
  const [assignmentAiModal, setAssignmentAiModal] = useState(false);
  const [generateQnALoader, setGenerateQnALoader] = useState(false);
  const [questionGenerator, setQuestionGenerator] = useState([]);
  const [qnaWord, setQnAWord] = useState("");
  const is_student = useMemo(()=>currentUser?.role=='student',[currentUser])
  const [generatedCount,SetGenerateCount] = useState(0)
  const questionRequestIdRef = useRef(0);
  const [openLanguageDropdown, setOpenLanguageDropdown] = useState(false);
  const TextReplaceIcon = window.innerWidth < 992;
  const vocab_list = useMemo(()=>{
    let words = '';
        if(listStory&&listStory.content){
          const {based_on,ownVocab=""} = listStory.content || {};
           if(based_on&&based_on.page_vocab){
               const filterVocab = filter(bookVocabulary, obj =>  obj.page == listStory.page);
               if(filterVocab.length){
                   words = filterVocab.map(item=>item.data.word||'').join(', ');
               }
           }
           if(ownVocab&&ownVocab.length){
            if(words && words.length > 0){
              words += ', ' + ownVocab;
            } else {
              words+= ownVocab;
             }
           }

        }
        return words.trim();
  },[listStory,bookVocabulary])
  const { isAiPermissionEnabled } = useUserProfileConfig();
  useEffect(() => {
    if (!deleteModal) {
      setStoryIdPendingDelete(null);
    }
  }, [deleteModal]);
  useEffect(() => {
    if (open && hasStoryWithAi?.length > 0) {
      setFrozenStories(hasStoryWithAi);
    }
  }, [open]);

  useEffect(() => {
    const handler = () => {
      if (document.querySelector(".story-view-modal-container")) {
        onClose();
      }
    };
    window.addEventListener("closeStoryViewModal", handler);
    return () => window.removeEventListener("closeStoryViewModal", handler);
  }, [onClose]);

  useEffect(() => {
    if (!open) return;
    if (!hasStoryWithAi?.length) {
      setFrozenStories([]);
      return;
    }
    setFrozenStories((prevStories) => {
      if (!prevStories?.length) {
        return hasStoryWithAi;
      }
      const prevIds = new Set(prevStories.map((s) => s?.id).filter(Boolean));
      const mergedFromPrev = prevStories
        .map((story) => hasStoryWithAi.find((item) => item?.id === story?.id))
        .filter(Boolean);
      const added = hasStoryWithAi.filter((item) => !prevIds.has(item?.id));
      return [...mergedFromPrev, ...added];
    });
  }, [hasStoryWithAi, open]);

  const storiesToUse = frozenStories?.length > 0 ? frozenStories : hasStoryWithAi;

  const resolvedStoryBody = useMemo(
    () =>
      handleStoryStream
        ? handleStoryStream
        : listStory
          ? listStory?.story_content
          : storiesToUse?.[0]?.story_content || '',
    [handleStoryStream, listStory, storiesToUse],
  );

  const [modalStoryBody, setModalStoryBody] = useState('');

  useEffect(() => {
    setModalStoryBody(resolvedStoryBody || '');
  }, [resolvedStoryBody, listStory?.id]);

  useEffect(() => {
    const validStories = storiesToUse?.filter(item => !isErrorContent(item?.story_content || '')) || [];
    
    if (handleStoryStream || handleStoryStreamTitle) {
      const streamTitle = typeof handleStoryStreamTitle === 'string' ? handleStoryStreamTitle : '';
      const listForNewStory = hasStoryWithAi?.filter(item => !isErrorContent(item?.story_content || '')) || [];
      const sortedForNew = [...listForNewStory].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
      const matchingNewStory = streamTitle && sortedForNew.find(
        (item) =>
          item.story_title === streamTitle ||
          item.story_title?.includes(streamTitle) ||
          streamTitle?.includes(item.story_title)
      );
      if (matchingNewStory) {
        setListStory(matchingNewStory);
        setSelectedValue(matchingNewStory?.id);
        setHandleStoryStreamTitle('');
        setHandleStoryStream('');
        setFrozenStories([]);
      }
      return;
    }
    if (listStory && listStory.id && listStory.id != handleStoryId) {
      const story_item = validStories?.find((item) => item?.id === listStory.id);
      if (story_item) {
        setListStory(story_item);
        setSelectedValue(story_item.id);
        if (regeneratingStoryId === story_item.id && regenerateLoader) {
          setRegenerateLoader(false);
          setRegeneratingStoryId(null);
        }
      return;
      }
    }
    if (listStory && listStory.id && listStory.id === handleStoryId) {
      const story_item = hasStoryWithAi?.find((item) => item?.id === listStory.id);
      if (story_item) {
        setListStory(story_item);
      }
    }
    if (handleStoryId) {
      const findStory = validStories?.find(
        (item) => item?.id === handleStoryId
      );
      if (findStory) {
        setListStory(findStory);
        setSelectedValue(findStory?.id);
      } else if (validStories?.length > 0) {
        setListStory(validStories[0]);
        setSelectedValue(validStories[0]?.id);
      }
    } else if (validStories?.length > 0) {
      setListStory(validStories[0]);
      setSelectedValue(validStories[0]?.id);
    }
  }, [storiesToUse, handleStoryId, hasStoryWithAi, handleStoryStream, handleStoryStreamTitle]);

  useEffect(() => {
    if (!regeneratingStoryId || !regenerateLoader || !hasStoryWithAi?.length || !previousStoryRef.current) {
      return;
    }
    const updatedStory = hasStoryWithAi.find((item) => item?.id === regeneratingStoryId);
    if (!updatedStory) {
      return;
    }
    const previousStory = previousStoryRef.current;
    const mediaChanged =
      JSON.stringify(previousStory.images || []) !== JSON.stringify(updatedStory.images || []) ||
      previousStory.male_audio !== updatedStory.male_audio ||
      previousStory.female_audio !== updatedStory.female_audio;
    const statusChanged =
      previousStory.updated_at !== updatedStory.updated_at ||
      previousStory.is_audio_generated !== updatedStory.is_audio_generated ||
      previousStory.is_image_generated !== updatedStory.is_image_generated ||
      JSON.stringify(previousStory.media_status || {}) !== JSON.stringify(updatedStory.media_status || {});

    if (mediaChanged || statusChanged) {
      if (regenerateTimeoutRef.current) {
        clearTimeout(regenerateTimeoutRef.current);
        regenerateTimeoutRef.current = null;
      }
      setFrozenStories([...hasStoryWithAi]);
      setListStory(updatedStory);
      setRegenerateLoader(false);
      setRegeneratingStoryId(null);
      previousStoryRef.current = null;
    }
  }, [hasStoryWithAi, regeneratingStoryId, regenerateLoader]);

  useEffect(() => {
    if (regeneratingStoryId && regenerateLoader) {
      regenerateTimeoutRef.current = setTimeout(() => {
        setRegenerateLoader(false);
        setRegeneratingStoryId(null);
        previousStoryRef.current = null;
        regenerateTimeoutRef.current = null;
      }, 90000);
    }
    return () => {
      if (regenerateTimeoutRef.current) {
        clearTimeout(regenerateTimeoutRef.current);
        regenerateTimeoutRef.current = null;
      }
    };
  }, [regeneratingStoryId, regenerateLoader]);

  const filterLesson =
    find(
      superLesson,
      (data) =>
        data?.userId === currentUser?.id &&
        data?.access_by?.includes(currentUser?.id)
    ) || {};
  const filterShareLesson =
    filter(
      superLesson,
      (data) =>
        data?.userId !== currentUser?.id &&
        data?.access_by?.includes(currentUser?.id)
    ) || [];
  const [filterMyData, setFilterMyData] = useState(filterLesson);
  const [filterSharedLesson, setFilterSharedLesson] =
    useState(filterShareLesson);
  const [selectedTeacherIds, setSelectedTeacherIds] = useState([]);
  const [initialValues, setInitialValues] = useState([]);
  const {updatePopUpAtOnce} = usePopUpAtOnce();
  const superData = filterMyData?.super_data ?? {};
  const standardText = superData?.standard || "";

  const maxChars = 27;

  const isTablate = useTabletDetection();
  const isMobile = useMobileDetect() && !isTablate;

  const formattedData = useMemo(() => {
    return storiesToUse
      ?.filter(item => !isErrorContent(item?.story_content || ''))
      ?.map((item) => ({
        value: item.id,
        label: item.story_title,
        shared_by: item.shared_from? item.shared_from.shared_by :null,
        role: item?.role
      }));
  }, [storiesToUse]);

  const checkUserHasFiveStory = useMemo(() => {
    const filterOwnStory = hasStoryWithAi.filter(record => 
      record?.role !== 'owe_admin' && Object.keys(record?.shared_from || {}).length === 0
    );
    return filterOwnStory?.length >= 6;
  },[hasStoryWithAi])


  useEffect(() => {
    if (viewLessonType === "shared") {
      setShowShareList(true);
    }
  }, [superLesson]);

  useEffect(() => {
    setFilterSharedLesson(filterShareLesson);
    setFilterMyData(filterLesson);
    setSelectedTeacherIds(filterLesson?.access_by || []);
    const initialAccessBy =
      filterLesson?.access_by?.filter(
        (element) => element !== filterLesson?.userId
      ) || [];
    setInitialValues(initialAccessBy);
  }, [superLesson]);

  const isDisable = () => {
    // const selectedTeacher = value?.map((element) => element?.value);
    // const combinedArray = [...selectedTeacher];
    // combinedArray.push(filterLesson?.userId);
    // const shareableArr = filter(
    //   combinedArray,
    //   (val) => val !== currentUser?.id
    // );
    // return shareableArr.length == 0 ? false : true;
    return true;
  };

  const isDisableBtn = () => {
    return true;
  };


  const validationPrint = () => {
    setPrintloader(true);
  if (isMobile || isTablate) {
    showAlert("Print is not supported on this device!", "error");
    setPrintloader(false);
    return;
  }

  addPrintableClass();

  // Add a delay to allow class updates to take effect
  setTimeout(() => {
    printCall();
    setPrintloader(true);
  }, 100); // 100ms is usually enough
};

const printCall = useReactToPrint({
  contentRef: imageRef,
  onBeforeGetContent: async () => {
    return new Promise((resolve) => {
      setPrintloader(true);
      setTimeout(() => resolve(), 100); // Wait for DOM/class changes
    });
  },
  onBeforePrint: async () => {
    setPrintloader(true);
  },
  onAfterPrint: async () => {
    setPrintloader(false);  
    removePrintableClass();
  },
});

  // const printCall = useReactToPrint({
  //   content: () => imageRef.current,
  //   onBeforeGetContent: () => {
  //     setPrintloader(true);
  //   },
  //   onBeforePrint: () => {
  //     setPrintloader(false);
  //   },
  //   onAfterPrint: () => {
  //     removePrintableClass();
  //   },
  // });

  const { Option } = AntSelect;

  const onGenerateAiActivity = async (language) => {
    if (!isAiPermissionEnabled) {
      showAlert('Please enable AI permission to generate questions.', 'error');
      return;
    }
    const requestId = questionRequestIdRef.current + 1;
    questionRequestIdRef.current = requestId;
    const storyData = listStory ? listStory : storiesToUse?.[0];
    setAssignmentAiModal(true);
    setGenerateQnALoader(true);
    const data = JSON.stringify({
      topic: storyData?.story_content,
      language: storyData?.content?.language,
      // question_type: "Open_Ended",
      storyId: storyData?.id,
      bookId: storyData?.chapter,
      story_proficiency: storyData?.content?.proficiencyLevel,
      resource: from !== "ebook" ? true : false,
      question_language: language
    });
    setQuestionGenerator([])
    try {
      await handleStreamResponse({
      path:"ai/generate/generate-questions-for-story",
      body:data,
      onTitle:(title)=>{
        if (questionRequestIdRef.current !== requestId) return;
        setQnAWord(title)
        SetGenerateCount(0)
      },
      onQuestion:(question)=>{
        if (questionRequestIdRef.current !== requestId) return;
        setQuestionGenerator(prev => [...prev, { ...question, id: Math.random() * 1000000000 }]);
        SetGenerateCount(prev => prev + 1)
        setQuestionLoader(false);
        setGenerateQnALoader(false);
      },
      onDone:()=>{
        if (questionRequestIdRef.current !== requestId) return;
        setGenerateQnALoader(false);
        setQuestionLoader(false);
        SetGenerateCount(0)
      },
      onError:()=>{
        if (questionRequestIdRef.current !== requestId) return;
        setGenerateQnALoader(false);
        setQuestionLoader(false);
        SetGenerateCount(0)
      }
    })
    } catch (error) {
      setAssignmentAiModal(true);
      setGenerateQnALoader(true);
    }
  };

  const handleGenerateMoreQnA = async (topic,languageKey) => {
    if (!isAiPermissionEnabled) {
      showAlert('Please enable AI permission to generate questions.', 'error');
      return;
    }
    const requestId = questionRequestIdRef.current + 1;
    questionRequestIdRef.current = requestId;
    setQuestionLoader(true);
     try {
      const data = JSON.stringify({
        topic,
        language: listStory?.content?.language,
        question_type: selectedTypes,
        storyId: listStory?.id,
        bookId: listStory?.chapter,
        story_proficiency: listStory?.content?.proficiencyLevel,
        question_language: languageKey ? languageKey :'spanish'
      })
       await handleStreamResponse({
         path: "ai/generate/generate-questions-for-story",
         body: data,
         onTitle: (title) => {
           if (questionRequestIdRef.current !== requestId) return;
           setQnAWord(title)
           SetGenerateCount(0)
         },
         onQuestion: (question) => {
           if (questionRequestIdRef.current !== requestId) return;
           setQuestionGenerator(prev => [...prev, { ...question, id: Math.random() * 1000000000 }]);
           SetGenerateCount(prev => prev + 1)
           setQuestionLoader(false);
           setGenerateQnALoader(false);
         },
         onDone: () => {
           if (questionRequestIdRef.current !== requestId) return;
           setGenerateQnALoader(false);
           setQuestionLoader(false);
           SetGenerateCount(0)
         },
         onError: () => {
           if (questionRequestIdRef.current !== requestId) return;
           setGenerateQnALoader(false);
           setQuestionLoader(false);
           SetGenerateCount(0)
         }
       })
     } catch (error) {
       setAssignmentAiModal(true);
       setGenerateQnALoader(true);
     }
    setQuestionLoader(false);
  };

  const onGenerateAiStory = async () => {
   // const my_story = filter(hasStoryWithAi, (item) => Object.keys(item?.shared_from || {}).length == 0)
    if (checkUserHasFiveStory)
      return showAlert(
        "You can only create 6 stories at a time, please delete any story before creating",
        "error"
      );
    setHandleStoryStream('');
    setHandleStoryStreamTitle('');
    setShowShareList(true);
    setFilterSharedLesson(filterShareLesson);
    setFilterMyData(filterLesson);
    onClose();
    onMoreStory();
  };

  const onDeleteStory = async () => {
    const idToDelete = storyIdPendingDelete ?? listStory?.id;
    if (!idToDelete) {
      return;
    }
    const storyToDelete =
      hasStoryWithAi?.find((s) => s.id === idToDelete) || listStory;
    try {
      setDeleteLoader(true);
      await dispatch(handleDeleteStoryAiConfig(idToDelete));
      setDeleteModal(false);
      dispatch(handleLearningModuleCount({
        chapter: storyToDelete?.chapter,
        userId: currentUser.id,
        pageId: storyToDelete?.page,
      }));
      if (selectedValue === idToDelete) {
        const deletedIndex = hasStoryWithAi?.findIndex(
          (story) => story.id === idToDelete
        );

        const updatedStories = hasStoryWithAi?.filter(
          (story) => story.id !== idToDelete
        );


        if (updatedStories?.length === 0) {
          updatePopUpAtOnce(false);
        }

        let nextSelectedStory = null;
        if (updatedStories?.length) {
          const newIndex = deletedIndex > 0 ? deletedIndex - 1 : 0;
          nextSelectedStory = updatedStories[newIndex];
        }

        setListStory(nextSelectedStory);
        setSelectedValue(nextSelectedStory?.id);
        setHandleStoryStreamTitle('');
        setHandleStoryStream('');
      }
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      setDeleteLoader(false);
    }
  };

  const regenerateStory = async (storyId) => {
    try {
      setRegenerateLoader(true);
    
      const mediaStatus = await dispatch(handleGetStoryMediaStatus(storyId));
      if (!mediaStatus) {
        setRegenerateLoader(false);
        return;
      }

      if(mediaStatus?.api_in_progress) {
          showAlert('Media is generating. Please wait for it.', 'info');
          setRegenerateLoader(false);
          return;
        }
      
  
        Modal.confirm({
          title: 'Regenerate story',
          content: 'Are you sure you want to regenerate story image?',
          okText: 'Yes, regenerate',
          cancelText: 'Cancel',
          onOk: async () => {
            try {
              const currentStory = hasStoryWithAi?.find((item) => item?.id === storyId);
              previousStoryRef.current = currentStory ? { ...currentStory } : null;
              setRegeneratingStoryId(storyId);
              await dispatch(handleRegenerateStory({
                storyId,
                is_audio_generated: false,
                is_image_generated: false
              }));
              showAlert('Regeneration started. Audio and images will update when ready.', 'info');
            } catch (error) {
              console.error('Error regenerating story:', error);
              showAlert('Failed to regenerate story. Please try again.', 'error');
              setRegenerateLoader(false);
              setRegeneratingStoryId(null);
              previousStoryRef.current = null;
            }
          },
          onCancel: () => {
            setRegenerateLoader(false);
            setRegeneratingStoryId(null);
            previousStoryRef.current = null;
          },
        });
      
    } catch (error) {
      console.error('Error regenerating story:', error);
      showAlert('Failed to regenerate story. Please try again.', 'error');
      setRegenerateLoader(false);
      setRegeneratingStoryId(null);
      previousStoryRef.current = null;
    }
  };

  // const generated_question = useMemo(
  //   () =>
  //     questionGenerator.map((k) => ({ ...k, id: Math.random() * 1000000000 })),
  //   [questionGenerator]
  // );
  const stripHtmlTags = (html) => html?.replace(/<[^>]*>/g, '') || '';

  const StoryLabel = (item) => {
    const { shared_by, label = '-', value, role } = item;
    let drop_label = stripHtmlTags(label) || ''
    const delete_icon = !is_student && role !== 'owe_admin' ? (
      <DeleteIcon
        onClick={(e) => {
          e.stopPropagation();
          setStoryIdPendingDelete(value);
          setDeleteModal(true);
        }}
      />
    ) : null;
    const shared_title = shared_by ? `(Shared by ${shared_by.firstName || ''} ${shared_by.lastName || ''})` : ''
    drop_label+=shared_title
    const cat_len_large = drop_label.length > 30;
    return (<Option key={value} value={value} label={drop_label}>
      <DropDownOption  >
        {delete_icon}
        <Tooltip title={cat_len_large ? drop_label : null} >
          <span>
            {
              drop_label
            }
            {/* {cat_len_large ? drop_label.slice(0, 30) + "..." : drop_label} */}
          </span>
        </Tooltip>       
      </DropDownOption>
    </Option>)
  }

  const languageMenuItems = [
    {
      key: 'spanish',
      label: 'Spanish',
      onClick:() => {
        onGenerateAiActivity('spanish');
      }
    },
    {
      key: 'english',
      label: 'English',
      onClick:() => {
        onGenerateAiActivity('english');
      }
    }
  ];

  const isStream = useMemo(() => {
    return handleStoryStream || handleStoryStreamTitle;
  }, [handleStoryStream, handleStoryStreamTitle]);

  return (
    <SentryWrap>
      <DeleteModal
        message={`Are you sure you want to delete?`}
        deleteToggle={deleteModal}
        setDeleteToggle={setDeleteModal}
        loading={deleteLoading}
        onDelete={onDeleteStory}
      />
      {open && (hasStoryWithAi?.length > 0 || (handleStoryStream && handleStoryStreamTitle)) && (
        <LessonContainer currentUser={currentUser} pathname={location.pathname} isCanvasUser={isCanvasUser}>
            <span
              onClick={() => {
                if(isStream){
                  showAlert('Please wait for the story to finish generating before closing.', 'error');
                  return;
                }
                setShowShareList(true);
                setFilterSharedLesson(filterShareLesson);
                setFilterMyData(filterLesson);
                setHandleStoryStream('');
                setHandleStoryStreamTitle('');
                setFrozenStories([]);
                updatePopUpAtOnce(false);
                onClose();
              }}
            >
              <div style={{position:'relative'}}>
              <Cancel
                style={{
                  float: 'right',
                  fontSize: viewLessonType === 'shared' && showShareList ? 25 : 20,
                  color: 'red',
                  background: 'white',
                  borderRadius: 20,
                  cursor: 'pointer',
                  marginBottom: 5,
                  zIndex: 20,
                  position: 'absolute',
                  right: 10,
                  top:10
                }}
              />
              </div>
            </span>
          <LessonModal
            soyHistoria={soyHistoria}
            style={{ position: 'relative', height: '100%', overflow:'hidden' }}
            view={viewLessonType === 'shared' && showShareList ? true : false}
            bookPage={location.pathname !== '/ebook'}
          >
            {(handleStoryStreamTitle || handleStoryStream) ? (
              <div className='cstmSkeleton'><Skeleton active paragraph={{ rows: 4 }} title={false} /></div>
             ) : ( 
              <Container className={open ? 'story-view-modal-container' : ''}>
                <div
                  className={`storyVwMdlCstm ${isCanvasUser ? 'canvasSuperLessonContainer' : 'widthStoryCont'}`}
                  style={{ width: '98%', marginTop:'30px' }}>
                  {!is_student ? (
                    <BoxContainer
                      className={isCanvasUser ? 'canvasSuperLessonBoxContainer' : ''}
                      style={{
                        marginRight: 6,
                        // marginLeft: 13,
                        marginBottom: 30,
                        width: '100%',
                      }}
                    >
                      <Label style={{ position: 'absolute', top: 13, zIndex: 9 }}>
                        <div style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
                        Soy Historias
                        <div style={{ cursor: "pointer", width: "50px", marginLeft: 'auto' }}>
                        <AIUsageInfo />
                        </div>
                        </div>
                      </Label>
                      <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          onGenerateAiStory();
                        }}
                      >
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                          }}
                        >
                          <AntdButton
                            // type="primary"
                            disabled={!isDisableBtn()}
                            style={{
                              borderRadius: 10,
                              border: '0px',
                              color: 'white',
                              cursor: isDisableBtn() ? 'pointer' : 'not-allowed',
                              backgroundColor: '#03989e',
                              width: TextReplaceIcon ? '55px' : 'fit-content',
                              // backgroundColor: isDisableBtn()
                              //   ? "#03989e"
                              //   : "#b3b3b3",
                            }}
                          >
                            {TextReplaceIcon ? (
                              <img
                                className=""
                                alt=""
                                src={StoryBoard}
                                style={{ width: 20, filter: 'invert(1)' }}
                              />
                            ) : (
                              'Generate Soy Historias'
                            )}
                          </AntdButton>
                        </span>
                      </div>
                      <Dropdown menu={{items: languageMenuItems}} trigger={['click']} open={openLanguageDropdown} onOpenChange={setOpenLanguageDropdown}>
                      <div
                        style={{ cursor: 'pointer' }}
                      
                      >
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                          }}
                        >
                          <AntdButton
                            // type="primary"
                            disabled={!isDisable()}
                            style={{
                              borderRadius: 10,
                              border: '0px',
                              color: 'white',
                              cursor: isDisable() ? 'pointer' : 'not-allowed',
                              backgroundColor: isDisable() ? '#03989e' : '#b3b3b3',
                            }}
                          >
                            {TextReplaceIcon ? (
                              <img
                                className=""
                                alt=""
                                src={Writing}
                                style={{ width: 25, filter: 'invert(1)' }}
                              />
                            ) : (
                              'Generate AI Activity'
                            )}
                            {openLanguageDropdown ? <KeyboardArrowUp  style={{color: 'white'}}/> : <KeyboardArrowDown style={{color: 'white'}}/>}
                          </AntdButton>
                        </span>
                      </div>
                      </Dropdown>
                      
                      <div
                        style={{ cursor: 'pointer', width: '50px' }}
                        onClick={() => {
                          validationPrint();
                        }}
                      >
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                          }}
                        >
                          <AntdButton
                            className="share-button-super-lesson"
                            // type="primary"
                            style={{
                              borderRadius: 10,
                              border: '0px',
                              color: 'black',
                              backgroundColor: '#03989e',
                            }}
                          >
                            {printLoader ? (
                              <Loading size={20} white />
                            ) : (
                              <Print style={{ color: 'white' }} />
                            )}
                          </AntdButton>
                        </span>
                      </div>
                      {listStory?.id && (
                        <div
                          style={{ cursor: 'pointer', width: TextReplaceIcon ? '50px' : 'fit-content', marginLeft: 4 }}
                          onClick={() => listStory?.id && regenerateStory(listStory.id)}
                        >
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                            }}
                          >
                            <AntdButton
                              disabled={regenerateLoader}
                              style={{
                                borderRadius: 10,
                                border: '0px',
                                color: 'white',
                                backgroundColor: '#03989e',
                                width: TextReplaceIcon ? '50px' : 'fit-content',
                              }}
                            >
                             
                              {regenerateLoader ? (
                                <Loading size={20} white />
                              ) : <Refresh />
                              }
                             
                            </AntdButton>
                          </span>
                        </div>
                      )}
                      {listStory?.role !== 'owe_admin' && (
                        <div style={{ cursor: 'pointer', width: '50px', marginLeft: 4 }}>
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                            }}
                          >
                            <StoryShare storyInfo={listStory || {}} />
                          </span>
                        </div>
                      )}
                      {!is_student &&
                      !(handleStoryStreamTitle || handleStoryStream) &&
                      (listStory || storiesToUse?.[0])?.user_id === currentUser?.id ? (
                        <div style={{ cursor: 'pointer', width: '50px', marginLeft: 4 }}>
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                            }}
                          >
                            <StoryTextEditor
                              storyInfo={listStory || storiesToUse?.[0] || {}}
                              text={modalStoryBody}
                              onSave={setModalStoryBody}
                            />
                          </span>
                        </div>
                      ) : null}
                    </BoxContainer>
                  ) : null}
                  <BoxContainer
                    className={isCanvasUser ? 'canvasSuperLessonBoxContainer' : ''}
                    style={{
                      marginRight: 6,
                      // marginLeft: 13,
                      marginBottom: 12,
                      position: 'relative',
                    }}
                  >
                    <Row
                      style={{
                        width: '100%',
                      }}
                    >
                      <Col span={vocab_list ? 12 : 24} lg={12} sm={24} xs={24}>
                        <Label style={{ position: 'absolute', zIndex: 9, top: -22 }}>
                          Your Story
                        </Label>
                        <Badge
                          overlap="rectangular"
                          badgeContent={formattedData.length > 0 ? formattedData?.length : undefined}
                          color="info"
                          variant="standard"
                          sx={{ width: '100%' }}
                        >
                          <FieldShareBox
                            style={{
                              background: 'none',
                              flex: '1',
                              border: 'none',
                              placeItems: 'start',
                            }}
                          >
                            <Space direction="vertical" style={{ width: '100%', overflow: 'hidden' }}>
                              <AntSelect
                                style={{ width: '100%' }}
                                placeholder="Select a story"
                                value={selectedValue}
                                onChange={(value) => {
                                  const StoryList = storiesToUse?.find(
                                    (story) => story.id === value,
                                  );
                                  setListStory(StoryList);
                                  setSelectedValue(value);
                                  setHandleStoryStreamTitle('');
                                  setHandleStoryStream('');
                                }}
                                className="dropdown-select"
                                optionLabelProp="label"
                              >
                                {formattedData.map((item) => StoryLabel(item))}
                              </AntSelect>
                            </Space>
                          </FieldShareBox>
                        </Badge>
                      </Col>
                      {vocab_list ? (
                        <Col
                          span={11}
                          lg={11}
                          sm={24}
                          xs={24}
                          style={{
                            ...(window.innerWidth <= 991 ? { marginTop: 25 } : {}),
                            ...(window.innerWidth >= 992 ? { marginLeft: 12 } : {}),
                          }}
                        >
                          <VocabDisplay vocab_list={vocab_list} />
                        </Col>
                      ) : null}
                    </Row>
                  </BoxContainer>
                </div>
              </Container>
            )} 
            <div className="soy-historia-print-wrapper" style={{overflow:'hidden'}}>
            <StoryWithImages
              openStoryWithAiView={open}
              imageConfiguration={imageConfiguration}
              ref={imageRef}
              images={listStory?.images || storiesToUse?.[0]?.images || []}
              text={modalStoryBody}
              storyEditableText={modalStoryBody}
              onStoryEditableTextChange={setModalStoryBody}
              title={handleStoryStreamTitle ? handleStoryStreamTitle : listStory?.story_title || ''}
              storyInfo={listStory || {}}
              is_student={is_student}
              isStream={(handleStoryStreamTitle || handleStoryStream)}
              soyHistoria={soyHistoria}
            />
            </div>
          </LessonModal>
        </LessonContainer>
      )}
      {assignmentAiModal && (
        <QnALoader
          assignmentAiModal={assignmentAiModal}
          setAssignmentAiModal={(val) => {
            if (!val) {
              questionRequestIdRef.current += 1;
              setQuestionGenerator([]);
              setGenerateQnALoader(false);
              setQuestionLoader(false);
              SetGenerateCount(0);
            }
            setAssignmentAiModal(val);
            setOpenStoryWithAiView(val);
          }}
          handleGenerateMoreQnA={handleGenerateMoreQnA}
          generateQnALoader={generateQnALoader}
          questionGenerator={questionGenerator}
          page={listStory ? listStory?.page : storiesToUse?.[0]?.page || ""}
          chapter={
            listStory ? listStory?.chapter : storiesToUse?.[0]?.chapter || ""
          }
          qnaWord={qnaWord}
          loading={questionLoader}
          assignmentTitle={qnaWord}
          selectedTypes={selectedTypes}
          setSelectedTypes={setSelectedTypes}
          storyInstruction={listStory?.id}
          generatedCount={generatedCount}
        />
      )}
    </SentryWrap>
  );
};

export default StoryViewModal;
